import React from 'react'
import PropTypes from 'prop-types'
import _isArray from 'lodash/isArray'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import Button, { TYPES } from '../Button/index'
import { URL_ACCOUNT_CREATION } from '../../services/url/constants'
import Link from '../Link/index'
import { getBoundActions } from '../../actions/index'

export const BUTTON_SIGN_UP_TYPE_LINK = 'link'
export const BUTTON_SIGN_UP_TYPE_BUTTON = 'button'

function ButtonSignUp (props) {
  const {
    text,
    buttonClass,
    buttonType,
    type,
    className,
    onClick,
    scrollToTop,
  } = props

  if (type === BUTTON_SIGN_UP_TYPE_LINK) {
    return (
      <span className="button-sign-up__link-container">
        <Link
          to={URL_ACCOUNT_CREATION}
          className={className}
          onClick={onClick}
          scrollToTop={scrollToTop}
        >{text}</Link>
      </span>
    )
  }

  if (type === BUTTON_SIGN_UP_TYPE_BUTTON) {
    return (
      <span className="button-sign-up__btn-container">
        <Button
          type={buttonType}
          className={_isArray(buttonClass) ? buttonClass.join(' ') : buttonClass}
          url={URL_ACCOUNT_CREATION}
          onClick={onClick}
          scrollToTop={scrollToTop}
        >
          {text}
        </Button>
      </span>
    )
  }
}

ButtonSignUp.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  buttonClass: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  scrollToTop: PropTypes.bool,
  buttonType: PropTypes.string,
}

ButtonSignUp.defaultProps = {
  buttonType: TYPES.PRIMARY,
}

export default compose(
  connectRedux(
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      }
    },
  ),
)(ButtonSignUp)
